import api from '../common/api/playlistApi';

const basePath = '/playlists';

export default {
  create(playlist) {
    return api.post(basePath, playlist);
  },
  get(playlistId, params = {}) {
    return api.get(`${basePath}/${playlistId}`, { params });
  },
  getEdit(playlistId, params = {}) {
    return api.get(`${basePath}/edit/${playlistId}`, { params });
  },
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  update(playlistId, playlistData) {
    return api.put(`${basePath}/${playlistId}`, playlistData);
  },
  delete(playlistId, params = {}) {
    return api.delete(`${basePath}/${playlistId}`, {params});
  },
  getAssociatedDistributions(playlistId, params = {}) {
    return api.get(`${basePath}/associated-distributions/${playlistId}`, { params });
  }
};



// WEBPACK FOOTER //
// ./src/services/playlistService.js